import * as types from "../mutation-types";
import { index as getSupportTickets } from "~/api/support";

export const state = {
    list: null,
    isLoading: false,
    isSubmitting: false
};

export const mutations = {
    [types.SET_IS_LOADING_SUPPORT_TICKETS](state, status) {
        state.isLoading = status;
    },
    [types.SET_SUPPORT_TICKETS](state, tickets) {
        state.list = Array.isArray(tickets) ? tickets : tickets?.data || [];
    },
    [types.SET_IS_SUBMITTING_SUPPORT_TICKET](state, status) {
        state.isSubmitting = status;
    }
};

export const actions = {
    async fetchTickets({ commit }) {
        commit(types.SET_IS_LOADING_SUPPORT_TICKETS, true);
        try {
            const { data } = await getSupportTickets();
            commit(types.SET_SUPPORT_TICKETS, data?.data ?? data);
        } finally {
            commit(types.SET_IS_LOADING_SUPPORT_TICKETS, false);
        }
    }
};

export const getters = {
    list: (state) => state.list,
    isLoading: (state) => state.isLoading,
    isSubmitting: (state) => state.isSubmitting
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};



